import HeaderShadow from '@helvetia/components/Header/HeaderShadow'
import Logo from '@helvetia/components/Header/Logo'
import { Col, Row } from '@helvetia/components/layout'
import { styled } from '@helvetia/components/theme'
import { media } from '@helvetia/components/theme/media'
import * as H from 'history'
import { rem } from 'polished'
import * as React from 'react'

import { getDefaultSelectedLanguage } from '../../core/services/storage.service'
import Footer from './footer'
import HeaderTitle from './HeaderTitle'
import LanguageSelector from './LanguageSelector'

interface Props {
  history: H.History
}

const Layout: React.SFC<Props> = ({ history, children }) => {
  return (
    <Wrapper>
      <Row
        justifyContent="flex-end"
        justifyItems="space-between"
        alignItems="flex-end"
        marginBottom="xxxs"
        marginTop="xxxs"
      >
        <Col mobile={6} tablet={6} desktop={6}>
          <HeaderTitle history={history} />
        </Col>
        <Col mobile={6} tablet={6} desktop={6}>
          <Row
            justifyContent="flex-end"
            justifyItems="flex-end"
            alignItems="center"
          >
            <Col mobile={7} tablet={4} desktop={4}>
              <LanguageSelector />
            </Col>
            <Col mobile={5} tablet={8} desktop={8}>
              <Logo lang={getDefaultSelectedLanguage()} />
            </Col>
          </Row>
        </Col>
      </Row>
      <HeaderShadow />
      <ContentWrapper>{children}</ContentWrapper>
      <Footer />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  max-width: 1360px;
  margin-left: auto;
  margin-right: auto;

  padding-left: ${media.onlyMobile ? rem(20) : rem(40)};
  padding-right: ${media.onlyMobile ? rem(20) : rem(40)};
`

const ContentWrapper = styled.div`
  max-width: 100%;
  padding-left: ${media.onlyMobile ? rem(10) : rem(25)};
  padding-right: ${media.onlyMobile ? rem(10) : rem(25)};
`
export default Layout
